import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const m = r((o, a) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: a,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m7 8.5H3v-2l5.293-5.293a1 1 0 0 1 1.414 0L13 9z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
m.displayName = "ImageIcon";
export {
  m as ImageIcon,
  m as default
};
//# sourceMappingURL=index.js.map
